import api from '../api';

export class SubscritpionPlan {
  static async getSubscritpionPlan() {
    return api.getApiCall('/api/v1/admins/subscription-plans');
  }
}
